export const PATH_NAMES = Object.freeze({
  SELECT_SHOP: 'shops',
  SELECT_TREATMENT: 'select-treatment/:shopName',
  TREATMENT_CATEGORY: 'treatment-category/:treatmentCategoryId',
  TREATMENT_BRAND: 'treatment-brand/:treatmentBrandId',
  SELECT_DATE: 'select-date',
  ABOUT_YOU: 'about-you',
  REVIEW: 'review',
  BOOKING: 'bookings/:bookingId',
  COMPLETED_BOOKING: 'completed-booking',

  EDIT_DATE: 'edit-date',
  EDIT_YOUR_DETAILS: 'edit-your-details',
});
